// @flow
import type { Dispatch, GetState } from '../../core/types'
import client, { services } from '../../core/feathers'
import { batch } from '../../modules/lib/batchReducer'
import { getUserId } from '../session'
import { BID_STATE } from './constants'
import {
  addOutbidItem,
  removeWinningItem,
  addWinningItem,
  removeOutbidItem,
  clearCurrentBids
} from './actions'

export default function configureBidListeners(
  dispatch: Dispatch,
  getState: GetState
) {
  client.on('logout', () => {
    dispatch(clearCurrentBids())
  })
  // server will patch a user bid once it's outbid
  services.bids.on('patched', bid => {
    const currentUserId = getUserId(getState())
    const outbid = BID_STATE.OUTBID
    if (bid.userId === currentUserId && bid.state === outbid) {
      dispatch(
        batch(
          'BID_PATCHED_SUCCESS',
          removeWinningItem(bid.itemId),
          addOutbidItem(bid.itemId)
        )
      )
    }
  })
  services.bids.on('created', bid => {
    const currentUserId = getUserId(getState())
    const winning = BID_STATE.WINNING
    if (bid.userId === currentUserId && bid.state === winning) {
      dispatch(
        batch(
          'BID_CREATED_SUCCESS',
          addWinningItem(bid.itemId),
          removeOutbidItem(bid.itemId)
        )
      )
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/bid/listeners.js